import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CHECK_CPF_CUSTOMER,
  CREATE_ASSOCIATES,
  DELETE_ASSOCIATES,
  GET_ASSOCIATES,
  GET_ORDER_ASSOCIATES,
  GET_SUMMARY_ASSOCIATES,
  UPDATE_ASSOCIATES,
} from './actionType';

// common success
export const AssociatesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const AssociatesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Associates = () => ({
  type: GET_ASSOCIATES,
});

export const GetSummaryAssociates = () => ({
  type: GET_SUMMARY_ASSOCIATES,
});

export const GetOrderAssociates = (params) => ({
  type: GET_ORDER_ASSOCIATES,
  payload: params,
});

export const CreateAssociates = (data, goToProposals, history) => ({
  type: CREATE_ASSOCIATES,
  payload: { data, goToProposals, history },
});

export const CheckCpfCustomer = (data) => ({
  type: CHECK_CPF_CUSTOMER,
  payload: data,
});

export const UpdateAssociates = (id, data, history) => ({
  type: UPDATE_ASSOCIATES,
  payload: { id, data, history },
});

export const DeleteAssociates = (id) => ({
  type: DELETE_ASSOCIATES,
  payload: { id },
});
